import { createSelector } from "reselect";
import translateObject from "../../utilities/translateObject";
import getRegion from "./getRegion";

const getSportTypeFilter = state => state.advisor.sportType;
const getSportVariants = state => state.sportVariants.data;

const selectSportVariants = createSelector(
  [getRegion, getSportTypeFilter, getSportVariants],
  (region, sportTypeId, sportVariants) => {
    if (sportTypeId) {
      return sportVariants
        .filter(sportVariant => sportVariant.sport_type_id === sportTypeId)
        .map(sportVariant => {
          return Object.assign({}, sportVariant, {
            name: translateObject(sportVariant.name, region.language)
          });
        });
    }

    return sportVariants.map(sportVariant => {
      return Object.assign({}, sportVariant, {
        name: translateObject(sportVariant.name, region.language)
      });
    });
  }
);

export default selectSportVariants;
